<template>
  <SoPageWithHeader>
    <SoContainer>
      <CustomerSearchResultsWidget />
    </SoContainer>

    <SoContainer class="d-flex">
      <SoCol :default-width="8" :mobile-width="8">
        <CustomerOperationNewsFeedsWidget />
      </SoCol>
      <v-spacer></v-spacer>
      <SoCol :default-width="3">
        <BugsInfoView />
      </SoCol>
    </SoContainer>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import CustomerSearchResultsWidget from "@/views/customer/search/widgets/CustomerSearchResultsWidget.vue"
  import headerBg from "@/assets/customer-search-header-bg.png"
  import headerBgDark from "@/assets/customer-search-header-bg-dark.png"
  import SoContainer from "@/components/SoContainer.vue"
  import SoCol from "@/components/SoCol.vue"
  import CustomerOperationNewsFeedsWidget from "@/views/customer/search/widgets/CustomerOperationNewsFeedsWidget.vue"
  import BugsInfoView from "@/views/bugsInfo/BugsInfoView.vue"

  export default defineComponent({
    components: {
      BugsInfoView,
      CustomerOperationNewsFeedsWidget,
      CustomerSearchResultsWidget,
      SoCol,
      SoPageWithHeader,
      SoContainer,
    },
    data() {
      return {
        headerBg,
        headerBgDark,
      }
    },
  })
</script>
<style lang="css" scoped>
  :deep(.v-input--density-compact) {
    margin-bottom: 0 !important;
  }
</style>
